import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginApi } from "../api/loginApi";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
  e.preventDefault();

  try {
    // const payload = { username, password };
    const payload = { 
      username: username.trim(), 
      password: password.trim() 
    };

    const response = await LoginApi(payload); // call API

    if (response.status) {
      // Save in session storage
      sessionStorage.setItem("username", response.username);
      sessionStorage.setItem("companyName", response.companyName);
      sessionStorage.setItem("email", response.email);
      sessionStorage.setItem("address",response.address);
      sessionStorage.setItem("role", response.userRoll);
      sessionStorage.setItem("userId",response.userID);
      // Save user rights (as JSON string)
      sessionStorage.setItem("userRights", JSON.stringify(response.userRights));


      // Pass username & company to parent (App)
      onLogin(response.username, response.companyName);

      // Redirect to welcome page
      navigate("/welcome");
    } else {
      alert(response.message || "Login failed!");
    }
  } catch (error) {
    console.error("Login error:", error);
    // alert("Something went wrong. Please try again.");
    alert("Login error: " + (error.message || error));
  }
};

  return (
    <div className="d-flex vh-100 justify-content-center align-items-center bg-light">
      <div className="card shadow p-4" style={{ width: "350px" }}>
        <h3 className="text-center mb-4">Login</h3>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">Username</label>

              <input
                type="text"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value.replace(/\s/g, ""))} 
                placeholder="Enter username"
                required
              />

          </div>

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value.replace(/\s/g, ""))}
              placeholder="Enter password"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary w-100">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
